import axios from 'axios';
import { resolveEncryptedResponse } from '../../utils/customerCrypto';
import { joinUrl, normalizeBaseUrl, REQUEST_TIMEOUT_MS } from './apiConfig';

function buildAuthFormData(fields) {
  const fd = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    fd.append(key, value ?? '');
  });
  return fd;
}

export async function loginForHealthMonitor(apiBaseInput, username, password, signal) {
  const apiBase = normalizeBaseUrl(apiBaseInput);
  if (!apiBase) {
    throw new Error('API base URL is required');
  }
  if (!username || !password) {
    throw new Error('Username and password are required');
  }
  const url = joinUrl(apiBase, 'ws-login-v2');
  const body = buildAuthFormData({
    username,
    password,
    deviceName: 'Web',
  });
  const res = await axios.post(url, body, {
    timeout: REQUEST_TIMEOUT_MS,
    signal,
    validateStatus: () => true,
  });
  const raw = res.data;
  const data = resolveEncryptedResponse(raw) || raw;
  const token = data?.jwtTokenWeb || data?.token || data?.jwtToken;
  if (!token) {
    const msg = data?.message || 'Login did not return a token';
    throw new Error(msg);
  }
  if (data?.success === false) {
    throw new Error(data?.message || 'Login failed');
  }
  return { token, prefix: data?.prefix, raw: data };
}
